<template>
  <div>
    <!-- Trilha de Auditoria Abertura do E-mail -->
    <div class="panel panel-default" v-if="hasTrilhaAuditoriaLeitura">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Trilha de Auditoria Abertura do E-mail</h3>
      </div>
      <ul class="list-group">
        <li class="list-group-item" v-if="detalhesLeitura.ipLeitura">
          IP: <strong>{{ detalhesLeitura.ipLeitura }}</strong>
        </li>
        <li class="list-group-item" v-if="detalhesLeitura.trilhaLeitura">
          <strong>Trilha de Leitura</strong>
          <pre class="carimbo" style="margin-top: 10px;">{{ detalhesLeitura.trilhaLeitura }}</pre>
        </li>
      </ul>
    </div>

    <!-- Hash Assinado -->
    <div class="panel panel-default" v-if="detalhesLeitura && detalhesLeitura.hashAssinado">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Hash Assinado</h3>
      </div>
      <ul class="list-group">
        <li class="list-group-item">
          <strong>{{ detalhesLeitura.hashAssinado }}</strong>
        </li>
      </ul>
    </div>

    <!-- Carimbo do Tempo -->
    <div class="panel panel-default" v-if="detalhesLeitura && detalhesLeitura.carimbo">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Carimbo do Tempo (Abertura)</h3>
      </div>
      <ul class="list-group">
        <li class="list-group-item" v-if="detalhesLeitura.ocorridoEm">
          Ocorrido em: <strong>{{ detalhesLeitura.ocorridoEm }}</strong>
        </li>
        <li class="list-group-item">
          <pre id="carimbo" style="margin-top: 10px;">{{ detalhesLeitura.carimbo }}</pre>
        </li>
        <li class="list-group-item" v-if="detalhesLeitura.emitidoPor">
          Certificado pela Autoridade do Carimbo do tempo ICP-Brasil
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppInfoEmailBrySendDetails',

  props: {
    detalhesLeitura: {
      type: Object
    }
  },

  computed: {
    hasTrilhaAuditoriaLeitura () {
      if (!this.detalhesLeitura) {
        return false
      }
      // Verifica se há trilha de leitura ou IP
      return !!(this.detalhesLeitura.trilhaLeitura || this.detalhesLeitura.ipLeitura)
    },

    timestampAuthorityName () {
      const emitidoPor = this.detalhesLeitura && this.detalhesLeitura.emitidoPor
      if (emitidoPor === 'SAFEWEB') {
        return 'SAFEWEB'
      }
      return 'Bry Tecnologia'
    },

    timestampAuthorityUrl () {
      const emitidoPor = this.detalhesLeitura && this.detalhesLeitura.emitidoPor
      if (emitidoPor === 'SAFEWEB') {
        return 'https://www.safeweb.com.br/'
      }
      return 'https://www.bry.com.br/'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/provider-bry/InfoEmailBryReadingDetails.vue